import { ChevronUpIcon, PlusCircleIcon, TrashIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { connect } from "react-redux";
import { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { addMonths, format } from "date-fns";

import FilterRow from "./FilterRow";
import BulkChangesModal from "./modals/BulkChangesModal";

import { Actions as GRADEACTIONS } from "../../store/actions/gradeActions";
import { Actions as EMPLOYEEACTIONS } from "../../store/actions/employeeActions";
import {DateInputFormat} from "@/common/DateComponents";
import DatePicker from "react-datepicker";

const EmployeeFilter = ({
	employees,
	setEmployees,
	filterOptions,
	gradesGetList,
	gradeList,
	setBulkChangesModal,
	employeesGetListWithSalary,
	saveFilters,
	reduxFilters,
	reduxChanges,
}) => {
	const [toggled, setToggled] = useState(false);
	const [effectiveDate, setEffectiveDate] = useState(false);
	const [filters, setFilters] = useState(reduxFilters);
	const [changes, setChanges] = useState(reduxChanges);
	const [filteredEmployeeList, setFilteredEmployeeList] = useState([]);

	const addFilter = () => {
		const newFilters = [...filters];

		newFilters.push({});

		setFilters(newFilters);
	};

	const addChange = () => {
		const newChanges = [...changes];

		newChanges.push({});

		setChanges(newChanges);
	};

	const filter = () => {
		var success = true;

		//Check if there are employees to filter, if not, return
		if (employees.length == 0) {
			NotificationManager.error("No employees to filter.", "Filters");
			return;
		}

		//Check if filters are empty, if so, return
		for (const filter in filters) {
			const filterValue = filters[filter]?.value;

			if (filterValue === null || filterValue === "") {
				NotificationManager.error("Filters cannot be left empty.", "Filters");
				success = false;
				break;
			}
		}

		//If the above checks fail, return
		if (!success) return;

		//Clone employees
		const newEmployees = [...employees];

		//Filter employees based on selected filters
		const filteredEmployees = newEmployees?.filter((employee) => {
			const employeeSalary = employee?.salaries[0];

			var filtered = false;

			filters?.map((filter) => {
				const filterValue = filter?.value;
				const selectedFilter = filter?.selectedFilter;

				//Check if the filter is an allowance filter, if so, check if the employee has the allowance
				if (selectedFilter?.value.includes("allowance")) {
					if (!employeeSalary?.allowances) {
						filtered = true;
						return false;
					}

					//if the employee does not have the allowance, filter them out
					if (
						!employeeSalary?.allowances?.find(
							(allowance) => allowance?.type == selectedFilter?.value.split("-").pop(),
						)
					) {
						filtered = true;
						return false;
					}

					//Check if the allowance amount matches the filter value
					employeeSalary?.allowances?.map((allowance) => {
						if (allowance?.type == selectedFilter?.value.split("-").pop()) {
							if (allowance?.amount == filterValue) {
								return;
							}
							filtered = true;
							return false;
						}
					});
					return;
				}

				//Check if the filter is a working days filter, if so, check if the employee working days matches
				if (selectedFilter?.type == "workingDays") {
					for (const i in filterValue) {
						if (employeeSalary?.workingDays?.sort()[i] != filterValue?.sort()[i]) {
							filtered = true;
							return false;
						}
					}
					return;
				}

				//Check if the filter value matches the employee value
				if (employeeSalary?.[selectedFilter?.value] != filterValue) {
					filtered = true;
					return false;
				}
			});
			if (!filtered) return true;
		});

		//If no employees match the filters, return
		if (filteredEmployees.length == 0) {
			return NotificationManager.error("No employees match the filters.", "Filters");
		}

		setEmployees(filteredEmployees);
		setFilteredEmployeeList(filteredEmployees);

		NotificationManager.success("Filters have been applied.", "Filters");
	};

	const verify = () => {
		var success = true;
		if (filteredEmployeeList.length == 0 || filters.length == 0)
			return NotificationManager.error("Apply filters, and ensure there are employees included before proceeding.", "Changes");

		if (changes.length == 0) return NotificationManager.error("No Changes to Preview and Apply.", "Changes");

		if (!effectiveDate) return NotificationManager.error("No Effective Date set; set a date before applying changes.", "Changes");

		//Check if changes are empty, if so, return
		for (const change in changes) {
			const changeValue = changes[change]?.value;

			if (changeValue === null || changeValue === "") {
				NotificationManager.error("Changes cannot be left empty.", "Changes");
				success = false;
				break;
			}
		}

		if (!success) return;
		setBulkChangesModal(true);
	};

	useEffect(() => {
		if (!gradeList) {
			gradesGetList();
		}
	}, []);

	return (
		<>
			<BulkChangesModal
				employees={filteredEmployeeList}
				changes={changes}
				employeesGetListWithSalary={employeesGetListWithSalary}
				effectiveDate={effectiveDate}
			/>

				<div
					onClick={() => setToggled(!toggled)}
					className={"absolute right-0 top-0 cursor-pointer py-4 px-2"}
				>
					<span style={{ float: "left" }}>Advanced Filters <sup>Beta</sup></span>
					<ChevronUpIcon
						style={{
							height: "1.5em",
							float: "left",
							marginLeft: 5,
							transform: toggled ? "rotateX(0deg)" : "rotateX(180deg)",
							transition: "transform 0.3s",
						}}
					/>
				</div>
			{toggled && (
					<div
						className="col-xs-12 py-10"
						style={{ borderTop: "1px solid rgb(187, 188, 188)" }}
					>
						<div
							className="col-xs-12"
							style={{ marginBottom: 5 }}
						>
							<h4>Advanced Filters</h4>
						</div>
						{filters?.map((filter, index) => {
							const selectedFilter = filter?.selectedFilter;
							const filterValue = filter?.value;

							//Update filters
							const updateField = (field, value) => {
								const newFilters = [...filters];
								const currentFilter = newFilters[index];

								currentFilter[field] = value;

								console.log({newFilters});

								setFilters(newFilters);
								saveFilters(newFilters, changes);
								setFilteredEmployeeList([]);
							};

							const removeField = () => {
								const newFilters = [...filters];
								newFilters.splice(index, 1);

								setFilters(newFilters);
								saveFilters(newFilters, changes);
								setFilteredEmployeeList([]);
							}

							return (
								<FilterRow
									type="filter"
									filters={filterOptions}
									updateField={updateField}
									removeField={removeField}
									selectedFilter={selectedFilter}
									filterValue={filterValue}
									secondaryValue={filter.secondaryValue}
								/>
							);
						})}
						<div className="col-xs-12">
							<button
								className="btn btn-success pull-left"
								type="button"
								onClick={() => addFilter()}
								style={{ padding: 5, marginRight: 10 }}
							>
								<PlusCircleIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							{filters.length > 0 && (
								<>
									<button
										className="btn btn-success pull-right"
										type="button"
										style={{ float: "right", marginRight: 10 }}
										onClick={() => filter()}
									>
										<span>Apply Filter</span>
									</button>
								</>
							)}
						</div>
						<div
							className="col-xs-12"
							style={{ marginBottom: 5, marginTop: 20 }}
						>
							<h4>Bulk Changes</h4>
						</div>
						{changes?.map((change, index) => {
							const selectedFilter = change?.selectedFilter;
							const filterValue = change?.value;

							//Update changes
							const updateField = (field, value) => {
								const newChanges = [...changes];
								const currentChange = newChanges[index];

								currentChange[field] = value;
								console.log({newChanges});

								setChanges(newChanges);
								saveFilters(filters, newChanges);
							};

							const removeField = () => {
								const newChanges = [...changes];
								newChanges.splice(index, 1);
								setChanges(newChanges);
								saveFilters(filters, newChanges);
							}

							//Allow only applied filters to be changed
							/*const appliedFilters = filterOptions?.filter((e) => {
								const filter = filters.find((f) => f?.selectedFilter?.value == e?.value);
								if (!filter) return false;
								return true;
							});*/

							return (
								<FilterRow
									type="change"
									filters={filterOptions}
									updateField={updateField}
									removeField={removeField}
									selectedFilter={selectedFilter}
									filterValue={filterValue}
									value={changes[index]?.value}
									secondaryValue={change.secondaryValue}
								/>
							);
						})}
						<div className="col-xs-12">
							<button
								className="btn btn-success pull-left"
								type="button"
								onClick={() => addChange()}
								style={{ padding: 5, marginRight: 10 }}
							>
								<PlusCircleIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							{changes.length > 0 && (
								<div className={"pull-right"}>
									{/* Request Selection of Effective Date for salary changes */}
									<div className="">
										<label
											// style={{
											// 	zIndex: "1",
											// 	position: "absolute",
											// 	top: "0px",
											// 	fontSize: "10px",
											// 	marginLeft: "5px",
											// }}
										>Effective Date</label>
										<DatePicker
											autoComplete="off"
											name="effectiveDate"
											dateFormat="do MMM yyyy"
											customInput={<DateInputFormat />}
											wrapperClassName="full-width"
											selected={effectiveDate ? new Date(effectiveDate) : null}
											onChange={(e) => {
												setEffectiveDate( e ? format(e, "yyyy-MM-dd") : null);
											}}/>
									</div>

									<button
										className="btn btn-success"
										type="button"
										onClick={() => verify()}
										style={{ float: "right", marginRight: 10 }}
									>
										<span>Preview Bulk Changes</span>
									</button>
								</div>
							)}
						</div>
					</div>
			)}
			<div className="clearfix" />
		</>
	);
};

const mapStateToProps = (state) => {
	const allowanceList = [
		...(state.allowances?.allowanceList?.filter(
			(a) => !a.public || a.public == "no" || a.canBeRecurring == "yes" || a.canBeRecurring == true,
		) || []),
		...(state?.company?.settings?.allowances?.filter((allowance) => !allowance.temporary) || []),
	];

	//Create list available options for filtering
	const filterOptions = [
		{ label: "Salary", value: "salaryAmount" },
		{ label: "Pay Frequency", value: "payPeriodFrequency" },
		{ label: "Salary Type", value: "net" },
		{ label: "Employment Type", value: "employmentType" },
		// { label: "Grade", value: "grade" },
		{ label: "Weekly Hours", value: "weeklyHours" },
		{ label: "Work Days", value: "workingDays" },
		{ label: "Hours worked in Q4", value: "previousHours" },
	];

	//Add allowances to filter options
	allowanceList?.map((allowance, index) => {
		if (index > 7) return;
		filterOptions.push({ label: allowance.allowanceName ?? allowance.name, value: `allowance-${allowance.id}` });
	});

	return {
		filterOptions,
		gradeList: state.grades.gradeList,
		reduxFilters: state.employees?.filters || [],
		reduxChanges: state.employees?.changes || [],
	};
};

const mapDispatchToProps = (dispatch) => ({
	gradesGetList: () => dispatch(GRADEACTIONS.gradesGetList()),
	setBulkChangesModal: (open) => dispatch(EMPLOYEEACTIONS.setBulkChangesModal(open)),
	employeesGetListWithSalary: ({ from, to }) =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary(
				{
					from: from ? from : format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
					to: to ? to : format(new Date(), "yyyy-12-31"),
				},
				{ includeTax: true },
			),
		),
	saveFilters: (filters, changes) => dispatch(EMPLOYEEACTIONS.employeeSaveFilters(filters, changes)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeFilter);
